import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import * as actions from '../usuarios/redux/actions';
import { REACT_APP_IMG } from '../../common/config';
import { WELCOME_LOGO_ASOFIX, WELCOME_EMAIL_FOOTER } from '../../common/assets'

class Welcome extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props){
    super(props);
    this.state = {
      lastname: '',
      firstname: '',
      id:''
    };
  }

  componentDidMount() {
    const params = this.props.match.params;
    this.props.actions.getUserById(params.id).then((data) => {
      this.setState({
        ...data
      });
    }).catch((errorMessage) => {
      toast.error(errorMessage)
      window.location.href = '/';
    });
  }

  render() {
    const { firstname, id } = this.state; 
    return (
      <div className="home-welcome" width="100%" >
    <center >

        <div  className="email-container">
            <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" >
                <tr>
                    <td className="logo-asofix-container">
                      <img src={`${REACT_APP_IMG}/${WELCOME_LOGO_ASOFIX}`}
                          width="150" height="100" 
                          alt="logo-asofix" 
                          className="logo-asofix" 
                          border="0" />
                    </td>
                </tr>
                <tr>
                    <td valign="middle" className="email-container__cover">
                        <table style={{width:'600px'}}>
                            <tr>
                                <td>
                                    <div className="email-container__content" >
                                        <h2 className="email-container__content__title">Te damos la bienvenida</h2><br/>
                                        <p className="email-container__content__description">{firstname} te han concedido acceso al sistema de gestión de concesionarios. <br/> ¡Ahora solo resta la activación de tu usuario para comenzar!</p><br/>
                                        <p><a href={`/usuarios/confirmar/${id}`} className="email-container__content__button">ACTIVAR MI USUARIO</a></p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
							<tr>
                <td
                className="email-container__footer" >
                  <img src={`${REACT_APP_IMG}/${WELCOME_EMAIL_FOOTER}`} width="150" height="100" alt="logo-asofix" border="0"
                  className="email-container__footer__logo"/>
								</td>
							</tr>
              </table>
          </div>
  </center>
</div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Welcome);
